module.exports = __webpack_public_path__ + "img/lubo_icon.391eba88.png";